import { useNavigate } from "react-router-dom";
import { AlertTriangle, MapPin } from "react-feather";
import Aviso from "@/components/project/Aviso";
import BuscaGrande from "@/components/project/BuscaGrande";
import Cabecalho from "@/components/project/Cabecalho";
import Rodape from "@/components/project/Rodape";
import { FaixaBeuni } from "@/components/project/Vitrine";

// Páginas fora do rastreio, no mesmo visual: endereço que não existe e erro
// inesperado na tela. Quem cai aqui também é de fora da beuni, então a faixa
// "Para empresas" vem junto.
function Moldura({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col bg-[#EDE4DA]">
      <Cabecalho />
      <main className="mx-auto w-full max-w-7xl flex-1 px-4 py-10 sm:px-6 sm:py-16">{children}</main>
      <FaixaBeuni />
      <Rodape />
    </div>
  );
}

export function PaginaNaoEncontrada() {
  const navigate = useNavigate();
  document.title = "Página não encontrada · betracking";
  return (
    <Moldura>
      <Aviso
        icone={<MapPin size={28} />}
        titulo="Esta página não existe"
        texto="O link pode estar incompleto ou ter mudado. Se você tem um código de rastreio, é só digitar abaixo."
      >
        <BuscaGrande onBuscar={(codigo) => navigate(`/track/${codigo}`)} />
        <a href="/" className="text-sm font-semibold text-[#C2410C] hover:underline">
          Ir para o início
        </a>
      </Aviso>
    </Moldura>
  );
}

// Fora do roteador (é o que aparece quando a tela quebra): só links comuns.
export function PaginaDeErro() {
  return (
    <Moldura>
      <Aviso
        icone={<AlertTriangle size={28} />}
        titulo="Algo deu errado por aqui"
        texto="Não conseguimos mostrar esta página agora. Recarregue ou volte ao início."
      >
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="inline-flex h-12 items-center rounded-xl bg-[#3F2021] px-6 font-bold text-white transition hover:bg-[#2c1617]"
        >
          Recarregar a página
        </button>
        <a href="/" className="text-sm font-semibold text-[#C2410C] hover:underline">
          Ir para o início
        </a>
      </Aviso>
    </Moldura>
  );
}
